export const SET_MARKET_PRICE = "SET_MARKET_PRICE";
export const SET_LAST_PRICE = "SET_LAST_PRICE";
export const SET_BOD_PRICE = "SET_BOD_PRICE";
export const SET_BET = "SET_BET";
